import axios from 'axios';
const list = (data) => axios.get('/menuSite/list', data);
const save = (data) => axios.post('/menuSite/save', data);
export default {
  list,
  save,

}


